import React from 'react';

const Loading = () => {
  return (
    <div className='flex justify-center mt-24'>
      <div className='loading'></div>
    </div>
  );
};

export default Loading;
